import React from 'react'
import MultiActionBarHeader, { IMultiActionBarProps } from './MultiActionDynamicHeader.component'
import MultiActionPanelComponent from '../multiActionPanel/MultiActionPanel.component'
import { IBottomSheetProps } from '../bottomSheetModal/BottomSheetModal.component'
import { IResizableDynamicPopoverProps } from '../resizableDynamicPopover/ResizableDynamicPopover.component'
import { IDropdownListSelectProps } from '../dropdownListSelect/DropdownListSelect.component'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'
import './MultiActionBar.component.css'

type TypeProps = IDropdownListSelectProps | IBottomSheetProps | IResizableDynamicPopoverProps

interface IMultiActionPanelProps extends IMultiActionBarProps {
  prefixContent?: any
  suffixContent?: any
  otherContent?: any
  typeProps?: TypeProps
}

const MultiActionBarComponent: React.FC<IMultiActionPanelProps> = ({
  label,
  prefixContent,
  suffixContent,
  otherContent,
  className,
  type,
  typeProps,
  ...restProps
}) => {
  const { isTablet } = useDeviceMetrics()
  type ComponentType = 'dropdown' | 'bottomSheetModal' | 'popover' | 'tabletSupportModal'

  const renderDynamicComponent = () => {
    const typePropsMapping: Record<ComponentType, any> = {
      dropdown: typeProps as IDropdownListSelectProps,
      bottomSheetModal: typeProps as IBottomSheetProps,
      popover: typeProps as IResizableDynamicPopoverProps,
      tabletSupportModal: isTablet ? (typeProps as IResizableDynamicPopoverProps) : (typeProps as IBottomSheetProps),
    }
    if (type in typePropsMapping) {
      return <MultiActionPanelComponent {...typePropsMapping[type as ComponentType]} type={type} />
    } else {
      return <></>
    }
  }

  return (
    <div className={`multi-action-bar-wrapper ${className}`}>
      <div className='prefix'>{prefixContent}</div>
      <MultiActionBarHeader
        isOpen={typeProps?.isOpen}
        label={label}
        type={type}
        className={`multi-action-bar ${className}`}
        {...restProps}>
        {renderDynamicComponent()}
      </MultiActionBarHeader>
      <div className='suffix'>{suffixContent}</div>
      {otherContent}
    </div>
  )
}

export default MultiActionBarComponent
